import { useEffect, useState } from "react";
import Logo from "@/components/feature/Logo";

const HOLD_MS = 1700;
const FADE_MS = 700;

export default function Preloader() {
  const [hidden, setHidden] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const t1 = window.setTimeout(() => setHidden(true), HOLD_MS);
    const t2 = window.setTimeout(() => setGone(true), HOLD_MS + FADE_MS);

    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  useEffect(() => {
    if (hidden) {
      document.body.style.overflow = "";
    }
  }, [hidden]);

  if (gone) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-primary-950 transition-opacity duration-700 ease-editorial ${
        hidden ? "pointer-events-none opacity-0" : "opacity-100"
      }`}
      aria-hidden={hidden}
    >
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div className="animate-ocean-drift absolute -left-24 top-0 h-[380px] w-[380px] rounded-full bg-secondary-700/20 blur-3xl" />
        <div className="absolute -right-20 bottom-0 h-[320px] w-[320px] rounded-full bg-primary-800/40 blur-3xl" />
      </div>

      <div className="relative z-10 flex flex-col items-center">
        <div className="preload-mark">
          <Logo size="lg" />
        </div>

        <p className="ocean-label mt-9 text-[10px] text-background-100/70 md:text-[11px]">
          Companhia de Comércio
        </p>

        <div className="mt-7 h-px w-40 overflow-hidden bg-background-100/15 md:w-52">
          <span className="preload-bar block h-full w-full bg-accent-500" />
        </div>
      </div>
    </div>
  );
}